export default __webpack_public_path__ + "static/media/image43.f369ebfb.png";